import { render, staticRenderFns } from "./searchProvider.vue?vue&type=template&id=7ceb6b0a"
import script from "./searchProvider.vue?vue&type=script&lang=js"
export * from "./searchProvider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports